<template>
    <div class="login">
        <b-container>
            <h1>Login</h1>

            <b-alert :show="error !== null" variant="danger">{{ error }}</b-alert>

            <b-form @submit="login" v-if="!newPasswordRequired">
                <b-form-group label="Username">
                    <b-form-input v-model="username" autofocus></b-form-input>
                </b-form-group>

                <b-form-group label="Password">
                    <b-form-input v-model="password" type="password"></b-form-input>
                </b-form-group>

                <b-button type="submit" class="btn-lg">Login</b-button>
            </b-form>

            <b-form @submit="submitNewPassword" v-if="newPasswordRequired">
                <p>You need to create a new password in order to log in. Please create your password below.</p>

                <b-form-group label="Password">
                    <b-form-input v-model="newPassword" type="password"></b-form-input>
                </b-form-group>

                <b-button type="submit" class="btn-lg">Continue</b-button>
            </b-form>
        </b-container>
    </div>
</template>

<script>
  import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
  import * as AWS from 'aws-sdk'

  export default {
    name: 'login',
    props: ['fb'],
    data () {
      return {
        username: '',
        // password: 'Test1234!',
        password: '',
        newPasswordRequired: false,
        newPassword: '',
        cognitoUser: null,
        error: null
      }
    },
    methods: {
      login () {
        AWS.config.region = 'eu-west-2'
        const userPool = new AmazonCognitoIdentity.CognitoUserPool({
          UserPoolId: 'eu-west-2_chYFmFWAP',
          ClientId: '11u0bf545urperp4ig57l8occ7'
        })
        this.cognitoUser = new AmazonCognitoIdentity.CognitoUser({
          Username: this.username,
          Pool: userPool
        })
        let authDetails = new AmazonCognitoIdentity.AuthenticationDetails({
          Username: this.username,
          Password: this.password
        })
        this.cognitoUser.authenticateUser(authDetails, {
          onSuccess: (result) => {
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: 'eu-west-2:9c052296-b683-4fe1-a205-9f4d89bafa41',
              Logins: {
                'cognito-idp.eu-west-2.amazonaws.com/eu-west-2_chYFmFWAP': result.getIdToken().getJwtToken()
              }
            })
            AWS.config.credentials.refresh((error) => {
              if (error) {
                this.error = error
              } else {
                // all good. log them in
                console.log('logging in...')
                this.$router.push('/')
              }
            })
            return true
          },
          onFailure: (result) => {
            this.error = result.message
            console.log('onFailure')
          },
          mfaRequired: (result) => {
            console.log('mfaRequired')
          },
          customChallenge: (result) => {
            console.log('customChallenge')
          },
          newPasswordRequired: (userAttributes, requiredAttributes) => {
            this.newPasswordRequired = true
          }
        })
      },
      submitNewPassword () {
        this.cognitoUser.completeNewPasswordChallenge(this.newPassword, {}, {
          onSuccess: (result) => {
            this.error = 'Thank you. Please now log in with your new password'
            this.newPasswordRequired = false
          },
          onFailure: (result) => {
            console.log('83', result)
            this.error = result.message
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue